var FORM = {
    checkFormLocationSpecial(location) {
        return location.indexOf('台湾省') != -1 || location.indexOf('海外地区') != -1;
    }
}

export {
    FORM
}